<div class="form-group">
  <mat-form-field class="example-full-width" appearance="outline">
    <mat-label class="defaultState">Assigned State</mat-label>
    <mat-select
      #assignedUserSelect
      [(ngModel)]="defaultState"
      (selectionChange)="optionChange()"
      multiple
    >
      @if (assignedUserSelect.focused) {
        <mat-option>
          <ngx-mat-select-search
            [formControl]="stateNameFilterCtrl"
            [noEntriesFoundLabel]="'No options found'"
            placeholderLabel="Filter"
            (filteredReturn)="filteredListOfState = $event"
          >
          </ngx-mat-select-search>
        </mat-option>
      }
      @for (item of filteredListOfState; track item) {
        <mat-option [value]="item.value">
          {{ item.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
